import { render } from "./OfferingComments.vue?vue&type=template&id=df1dfb64&scoped=true"
import script from "./OfferingComments.vue?vue&type=script&lang=js"
export * from "./OfferingComments.vue?vue&type=script&lang=js"

import "./OfferingComments.vue?vue&type=style&index=0&id=df1dfb64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-df1dfb64"

export default script